import { connect } from "react-redux"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import useMountEffect from "hooks/mount-effect"
import Loading from "components/loading"

function PlanConditionalRedirect({ plan, proRedirect, defaultRedirect }) {
  const navigate = useNavigate()

  useMountEffect(() => {
    switch (plan) {
      case "pro":
        navigate(proRedirect, { replace: true })
        break
      default:
        navigate(defaultRedirect, { replace: true })
    }
  })

  return <Loading />
}

PlanConditionalRedirect.propTypes = {
  plan: PropTypes.string.isRequired,
  defaultRedirect: PropTypes.string.isRequired,
  proRedirect: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => ({
  plan: state.global.selected.accountMeta.plan,
})

export default connect(mapStateToProps)(PlanConditionalRedirect)
